import React from 'react';
import { ProfileCompletionForm } from '@/components/ProfileCompletionForm';

const ProfileCompletionPage: React.FC = () => {
  return <ProfileCompletionForm />;
};

export default ProfileCompletionPage;